import { Box, styled } from '@mui/material';

import {
  JIIMGStyle,
  HyphenStyle,
  JIIMGContainerStyle,
  PeriodContainerStyle,
  JobItemContainerStyle,
  JobItemInfoContainerStyle,
} from './JobItem.types';

const JobItemContainerPadding = 24;

export const JobItemContainer = styled('div')(
  ({ shadow, short, background, hoverBackground }: JobItemContainerStyle) =>
    short
      ? {
          padding: `${JobItemContainerPadding}px`,

          boxShadow: `1px 1px 8px 1px ${shadow}`,
          borderRadius: '6px',

          display: 'flex',
          boxSizing: 'border-box',
          cursor: 'pointer',
          overflow: 'hidden',

          backgroundColor: background,

          transition: 'background-color .3s linear',

          '&:hover': {
            backgroundColor: hoverBackground,
          },

          '@media screen and (max-width: 640px)': {
            padding: `${JobItemContainerPadding / 4}px`,
          },
        }
      : {
          width: '100%',
          padding: `${JobItemContainerPadding}px`,

          boxShadow: `1px 1px 8px 1px ${shadow}`,
          borderRadius: '6px',

          display: 'grid',
          gridTemplateColumns: `25% calc(75% - ${JobItemContainerPadding}px)`,
          columnGap: '24px',
          boxSizing: 'border-box',
          cursor: 'pointer',
          overflow: 'hidden',

          backgroundColor: background,

          transition: 'background-color .3s linear',

          '&:hover': {
            backgroundColor: hoverBackground,
          },

          '@media screen and (max-width: 640px)': {
            padding: `${JobItemContainerPadding / 4}px`,
          },
        },
);

export const PeriodContainer = styled('div')(
  ({ short }: PeriodContainerStyle) => ({
    width: '100%',
    margin: 'auto 0',

    display: short ? 'none' : 'flex',
    flexDirection: 'column',
    whiteSpace: 'nowrap',
  }),
);

export const Hyphen = styled(Box)(({ color }: HyphenStyle) => ({
  '&:after': {
    content: '""',
    margin: 'auto',
    width: '16px',
    height: '4px',
    display: 'inline-block',
    background: color,
    transform: 'skewX(-20deg)',
  },
}));

export const EndPeriodContainer = styled(Box)(() => ({
  marginLeft: '24px',

  display: 'flex',
  flexDirection: 'row',
  columnGap: '12px',
}));

export const JobItemInfoContainer = styled('div')(
  ({ short }: JobItemInfoContainerStyle) => ({
    display: short ? 'none' : 'grid',
    gridTemplateColumns: 'auto 1fr',
    columnGap: '24px',
  }),
);

export const JobItemInfo = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  rowGap: '24px',

  whiteSpace: 'nowrap',
}));

export const JobItemInfoTitle = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const JobItemInfoCharacteristic = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '6px',
}));

export const JIIMG = styled('img')(({ short }: JIIMGStyle) => ({
  width: `${short ? 64 : 150}px`,
  height: `${short ? 64 : 150}px`,
  objectFit: 'cover',
  borderRadius: '50%',

  margin: 'auto 0',

  '@media screen and (min-width: 1920px)': {
    width: '150px',
    height: '150px',
  },

  '@media screen and (max-width: 1280px)': {
    width: `${short ? 64 : 128}px`,
    height: `${short ? 64 : 128}px`,
  },

  '@media screen and (max-width: 640px)': {
    width: '44px',
    height: '44px',
  },
}));

export const JIIMGContainer = styled('div')(
  ({ short }: JIIMGContainerStyle) => ({
    display: short ? 'flex' : 'none',
    margin: 'auto',
  }),
);
